export default "__VITE_ASSET__Dv3bfrOH__"